export default __webpack_public_path__ + "static/media/page11.0f845d4b.jpg";